<template>
  <v-container>
    <location-list-2 />
  </v-container>
</template>
<script>
export default {
	mounted() {
		this.$nextTick(() => {
			this.$vuetify.goTo(0)
		})
	}
}
</script>
